import { useResolvedUserPreferences } from '@atlaskit/editor-common/user-preferences';
import { updateUserPreference as _updateUserPreference } from './pm-plugins/commands';
import { createPlugin, userPreferencesPluginKey } from './pm-plugins/main';
import { useDocumentVisibilityWatcher } from './ui/useDocumentVisibilityWatcher';
import { useUserPreferencesInitListener } from './ui/useUserPreferencesInitListener';
import { useUserPreferencesUpdateListener } from './ui/useUserPreferencesUpdateListener';
export var userPreferencesPlugin = function userPreferencesPlugin(_ref) {
  var config = _ref.config,
    api = _ref.api;
  var userPreferencesProvider = config.userPreferencesProvider;
  return {
    name: 'userPreferences',
    pmPlugins: function pmPlugins() {
      return [{
        name: 'userPreferencesPlugin',
        plugin: function plugin() {
          return createPlugin(config, api);
        }
      }];
    },
    actions: {
      updateUserPreference: function updateUserPreference(key, value) {
        var _api$analytics;
        return _updateUserPreference({
          key: key,
          value: value,
          userPreferencesProvider: userPreferencesProvider,
          editorAnalyticsApi: api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions
        });
      },
      getUserPreferences: function getUserPreferences() {
        if (!userPreferencesProvider) {
          return config.initialUserPreferences;
        }
        return userPreferencesProvider.getPreferences();
      }
    },
    getSharedState: function getSharedState(editorState) {
      if (!editorState) {
        return null;
      }
      return userPreferencesPluginKey.getState(editorState);
    },
    usePluginHook: function usePluginHook(_ref2) {
      var editorView = _ref2.editorView;
      var _useResolvedUserPrefe = useResolvedUserPreferences(userPreferencesProvider),
        resolvedUserPreferences = _useResolvedUserPrefe.resolvedUserPreferences;
      useUserPreferencesUpdateListener(editorView, resolvedUserPreferences);
      useDocumentVisibilityWatcher(userPreferencesProvider);
      useUserPreferencesInitListener(Boolean(userPreferencesProvider === null || userPreferencesProvider === void 0 ? void 0 : userPreferencesProvider.isInitialized), resolvedUserPreferences, api);
    }
  };
};